export default class Option {
  constructor (id, stateObj, menu, cartElementBuilder) {
    this.stateObj = stateObj
    this._optionDefinition = menu.options[id]
    this._menu = menu
    this.cartElementBuilder = cartElementBuilder
  }

  get id () { return this._optionDefinition.id }
  get itemId () { return this._optionDefinition.itemId }
  get questionIds () { return this._optionDefinition.questions || [] }
  get title () { return this._optionDefinition.title || '' }
  get price () { return parseFloat(this._optionDefinition.price) }
  get kitchenStationId () {
    return this._optionDefinition.kitchenStationId || {}
  }
  get questions () {
    return this.questionIds.map(qid => this.cartElementBuilder.buildQuestion(qid, this.stateObj, this._menu))
  }

  get totalPrice () {
    return parseFloat(this.price + (this.questions.length === 0
      ? 0
      : this.questions.map(q => q.totalPrice).reduce((t, n) => t + n)))
  }

  get inValidQuestions () {
    return this.questions.length !== 0
      ? this.questions.reduce((r, q) => r.concat(q.inValidQuestions), [])
      : []
  }

  toString () {
    return this.title +
      (this.price > 0
        ? ' +' + this.price + '元'
        : this.price.price < 0 ? ' ' + this.price.price + '元' : '')
  }
}
